function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "thumb_down_alt");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "thumb_down_alt",
  stroke: "current",
  strokeWidth: 0,
  fill: "current",
  fillRule: "evenodd",
  fillOpacity: 0
}, React.createElement("g", {
  id: "mood",
  fill: "current"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 20 0 20 20 0 20"
}), React.createElement("g", {
  id: "Group-4",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("circle", {
  id: "Oval",
  stroke: "current",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  cx: 8,
  cy: 8,
  r: 8
}), React.createElement("path", {
  d: "M6,12.3284271 C8.209139,12.3284271 10,10.5375661 10,8.32842712",
  id: "Path",
  stroke: "current",
  strokeWidth: 1.25,
  strokeLinecap: "square",
  transform: "translate(8.000000, 10.328427) rotate(45.000000) translate(-8.000000, -10.328427) "
}), React.createElement("g", {
  id: "Group-10",
  transform: "translate(4.500000, 5.000000)",
  stroke: "none",
  fill: "current",
  fillOpacity: 1
}, React.createElement("circle", {
  id: "Oval",
  cx: 1,
  cy: 1,
  r: 1
}), React.createElement("circle", {
  id: "Oval-Copy",
  cx: 6,
  cy: 1,
  r: 1
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/mood.be8173f8.svg";
export { SvgComponent as ReactComponent };